export default __webpack_public_path__ + "files/3080088c13f19cdd6a7d095a3f6ec762.png";